<template>
  <div id="app">
    <Header v-model="activeIndex" :lang="lang" :active-index="activeIndex" @changLang="onChangeLan"></Header>
    <div class="main-content">
      <router-view class="content" :lang="lang"></router-view>
    </div>
    <Footer :lang="lang" @changLang="onChangeLan"></Footer>
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import { getLang, setLang } from '@/utils'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      activeIndex: '',
      lang: 'zh'
    };
  },
  created(){
    this.lang = getLang()
    this.activeIndex =this.$route.path
  },
  watch: {
    '$route':'getPath'
  },
  methods: {
    getPath(){
      this.activeIndex =this.$route.path
    },

    onChangeLan(lang='', str='') {
      if(lang) {
        this.lang = lang
      } else {
        this.lang = this.lang === 'en' ? 'zh' : 'en'
      }
      setLang(this.lang)
    }
  }
}
</script>

<style lang="less">
@import "style/global.less";
@import "style/common.less";
#app {
  background-color: #ebebeb;
  .main-content {
    background-color: #ebebeb;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue